<template>
  <card title="Dashboard Element" class="w-full">
    <div v-if="loading">
      <MoonLoader class="loading"></MoonLoader>
    </div>
    <div v-else>
      <div class="row">
        <div class="col dashboard-element__icon-block">
          <fg-input
            type="file"
            :label="$t('manage_question.icon')"
            @fileAttached="$v.form.icon_url.$model = $event"
            :value="$v.form.icon_url.$model"
            :class="{ 'form-group--error': $v.form.icon_url.$error }"
          ></fg-input>
          <div v-if="$v.form.icon_url.$error">
            <div class="error" v-if="!$v.form.icon_url.required">Field is required</div>
          </div>
        </div>
        <div class="col-6 form-group" :class="{ 'form-group--error': $v.form.headline.$error }">
          <label>Headline (max: 255)</label>
          <textarea
            rows="3"
            class="form-control border-input"
            placeholder="Use of organic pest control products for buildings"
            maxlength="255"
            v-model="$v.form.headline.$model"
          >
          </textarea>
          <div v-if="$v.form.headline.$error">
            <div class="error" v-if="!$v.form.headline.required">Field is required</div>
          </div>
        </div>
        <div class="col">
          <label for="display" class="control-label">{{ $t('manage_question.display') }}</label>
          <fg-input
            id="display"
            type="radio"
            @checked="form.display = $event"
            :selected="form.display === 'true' || form.display === '1'"
          >
          </fg-input>
        </div>
      </div>
    </div>
  </card>
</template>

<script>
import MoonLoader from '@/components/svg/SvgLoaderMoon';
import { numeric, required } from 'vuelidate/lib/validators';
export default {
  name: 'DashboardElementCreateForm',
  components: { MoonLoader },
  props: {
    dashboardElement: Object,
  },
  data() {
    return {
      loading: false,
      form: {
        icon_url: null,
        display: false,
        headline: null,
      },
    };
  },
  validations: {
    form: {
      icon_url: {
        required,
      },
      headline: {
        required,
      },
    },
  },
  watch: {
    form: {
      handler(newVal) {
        this.$emit('formChanged', { value: newVal });
      },
      deep: true,
    },
  },
  async mounted() {
    this.loading = true;
    await this.setFrom();
    this.loading = false;
  },
  methods: {
    setFrom() {
      if (this.dashboardElement) this.form = this.dashboardElement;
    },
    submit() {
      this.$v.$touch();
    },
  },
};
</script>

<style scoped></style>
